import React from "react";
import { Container, Row, Card, CardBody } from "reactstrap";
import ProfileProducts from "../../Users/UserDetails/Profile/components/ProfileProducts";
import ProductsFilter from "./filters";
import * as websites from "../../../../shared/service/websites";
import * as usages from "../../../../shared/service/usages";
import * as products from "../../../../shared/service/products";
import moment from "moment";

var date = new Date();
var startDate = moment(date).add(-6, "months");
var endDate = moment(
  new Date(date.getFullYear(), date.getMonth() + 1, date.getDate())
);

class SubscriptionsListing extends React.Component {
  state = {
    title: "Subscriptions",
    websites: [],
    usages: [],
    validity: products.getValidDays,
    concurrentConnections: products.concurrentConnections,
    types: products.productTypes,
    statuses: products.statuses,
    startDate: startDate,
    endDate: endDate,
    filters: {
      created: {
        from: startDate.format("YYYY/MM/DD"),
        to: endDate.format("YYYY/MM/DD"),
      },
    },
  };

  componentDidMount() {
    this.getWebsites();
    this.getUsages();

    this.child = React.createRef();
  }

  filterProducts = (filters) => {
    this.setState({ filters: filters }, () => {
      this.child.current.filter(this.state.filters);
    });
  };

  getWebsites = () => {
    websites.get().then((response) => {
      this.setState({ websites: response.data });
    });
  };

  getUsages = () => {
    usages.get().then((response) => {
      this.setState({ usages: response.data });
    });
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <ProductsFilter
            state={this.state}
            filterProducts={(filters) => {
              this.filterProducts(filters);
            }}
            type={this.props.type}
          />
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">
                  {this.props.type === "active" ? (
                    <span>Active&nbsp;{this.state.title}</span>
                  ) : this.props.type === "terminate_pending" ? (
                    <span>Cancellation Requests</span>
                  ) : this.props.type === "refresh_pending" ? (
                    <span>Refresh Requests</span>
                  ) : this.props.type === "inactive" ? (
                    <span>Inactive&nbsp;{this.state.title}</span>
                  ) : (
                    <span>All&nbsp;{this.state.title}</span>
                  )}
                </h5>
              </div>
              <ProfileProducts
                websites={this.state.websites}
                usages={this.state.usages}
                filters={this.state.filters}
                ref={this.child}
              />
            </CardBody>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default SubscriptionsListing;
